import { render, staticRenderFns } from "./claimsSelect.vue?vue&type=template&id=1d2ae664"
import script from "./claimsSelect.vue?vue&type=script&lang=js"
export * from "./claimsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports